import React, { useEffect, useState } from "react";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { QueryClient } from "@tanstack/react-query";
import PropTypes from "prop-types";
import ChatBotWindow from "./chatbot-window";
import { MessageStoreProvider } from "./message-store-context";
import { useGetChatBotInitMessage } from "./hooks";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 1000 * 60 * 60 * 24, // 24 hours
    },
  },
});

const persister = createSyncStoragePersister({
  storage: window.localStorage,
});

const ChatBot = ({ config }) => {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{ persister }}
    >
      <ChatBotWithStorage config={config} />
    </PersistQueryClientProvider>
  );
};

ChatBot.propTypes = {
  config: PropTypes.object,
};

const ChatBotWithStorage = ({ config }) => {
  const { data, isLoading, isError } = useGetChatBotInitMessage(
    config.chatbot_api_url,
  );
  const [initMessage, setInitMessage] = useState("Loading...");
  const defaultInitMessage =
    "Hi, I’m Leafie! \n I’m an experimental AI agent for eLTER users and researchers, here to help you understand eLTER and explore its research infrastructure sites, services, and datasets for long-term ecosystem research. \n \n Want to chat more? You can also find me at [leafie.dev.elter-ri.eu](https://leafie.dev.elter-ri.eu).";

  useEffect(() => {
    if (!isLoading) {
      if (!data) {
        setInitMessage(defaultInitMessage);
      } else {
        setInitMessage(data);
      }
    }
  }, [data, isError]);

  return (
    <MessageStoreProvider initMessage={initMessage}>
      <ChatBotWindow config={config} />
    </MessageStoreProvider>
  );
};

export default ChatBot;
